import { rootStoreReducer } from '@cobliteam/store/src/reducers';
import { applyMiddleware, compose, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import SagaMiddlewares from './sagas';

const sagaMiddleware = createSagaMiddleware();

const composeEnhancers = (process.env.NODE_ENV !== 'production' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const middleware = applyMiddleware(sagaMiddleware);

export const store = createStore(rootStoreReducer, undefined, composeEnhancers(middleware));

SagaMiddlewares(sagaMiddleware);
